import * as ActionConfigurationManager from './config.actions';

export const setPaymentOptionMax = ActionConfigurationManager.SAVE_PAYMENT_OPTIONS_MAX;

